module.exports = __webpack_public_path__ + "static/media/subject_icon.cde66d6d.svg";